import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { LanguageProvider } from './contexts/LanguageSwitcher';
import { WhatsappProvider } from './contexts/WhatsappCart';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const root = ReactDOM.createRoot(document.getElementById('root'));

// You can customize this theme later
const theme = createTheme();

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <LanguageProvider>
        <WhatsappProvider>
          <App />
        </WhatsappProvider>
      </LanguageProvider>
    </ThemeProvider>
  </React.StrictMode>
);
